import { render } from "./mainDashboard.vue?vue&type=template&id=43387fea&scoped=true"
import script from "./mainDashboard.vue?vue&type=script&lang=js"
export * from "./mainDashboard.vue?vue&type=script&lang=js"

import "./mainDashboard.vue?vue&type=style&index=0&id=43387fea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43387fea"]])

export default __exports__